import { useCallback, useRef, useState } from "react";
import AdminShell from "@/components/feature/AdminShell";
import ConnectionTab from "./components/ConnectionTab";
import TemplatesTab from "./components/TemplatesTab";
import AgentTab from "./components/AgentTab";
import InboxTab from "./components/InboxTab";

type TabKey = "conexion" | "plantillas" | "agente" | "bandeja";

const TABS: { key: TabKey; label: string; icon: string }[] = [
  { key: "conexion", label: "Conexión", icon: "ri-plug-line" },
  { key: "plantillas", label: "Plantillas", icon: "ri-file-list-3-line" },
  { key: "agente", label: "Agente IA", icon: "ri-robot-2-line" },
  { key: "bandeja", label: "Bandeja", icon: "ri-chat-3-line" },
];

export default function AdminWhatsApp() {
  const [tab, setTab] = useState<TabKey>("conexion");
  const [toast, setToast] = useState<string | null>(null);
  const timer = useRef<number | null>(null);

  const notify = useCallback((m: string) => {
    setToast(m);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast(null), 3200);
  }, []);

  return (
    <AdminShell title="WhatsApp" description="Conecta la API de WhatsApp de Meta, gestiona las plantillas, entrena al agente de IA y atiende las conversaciones.">
      <div className="flex gap-1 overflow-x-auto mb-5 border-b border-background-200" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.key}
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => setTab(t.key)}
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-semibold whitespace-nowrap cursor-pointer border-b-2 -mb-px ${
              tab === t.key ? "border-primary-500 text-foreground-950" : "border-transparent text-foreground-500 hover:text-foreground-800"
            }`}
          >
            <i className={`${t.icon} text-base`}></i>
            {t.label}
          </button>
        ))}
      </div>

      {tab === "conexion" ? <ConnectionTab notify={notify} goTemplates={() => setTab("plantillas")} /> : null}
      {tab === "plantillas" ? <TemplatesTab notify={notify} /> : null}
      {tab === "agente" ? <AgentTab notify={notify} /> : null}
      {tab === "bandeja" ? <InboxTab notify={notify} /> : null}

      {toast ? <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] bg-background-950 text-foreground-50 text-sm font-semibold px-4 py-2.5 rounded-full shadow-lg">{toast}</div> : null}
    </AdminShell>
  );
}
